/* eslint-disable class-methods-use-this */
import Model from './Model';

export default class Country extends Model {
    // noinspection JSMethodCanBeStatic
    primaryKey() {
        return 'value';
    }
}
